import * as React from "react";
import { FC } from "react";
import { IFilterConfig } from "../Map/config";
import { useDemoContext } from "./DemoContext";
import { Collapsible } from "./Collapsible";
import { Option } from "../Map/enums";

export interface IDemoFiltersProps {
    filtersConfig: IFilterConfig[];
    onNearbyChange: CallableFunction;
}

export const DemoFilters: FC<IDemoFiltersProps> = ({ filtersConfig, onNearbyChange }: IDemoFiltersProps) => {
    return (
        <>
            <Collapsible title="Filtrs: kategorija" defaultCollapsed={true}>
                <div className="list filters">
                    {renderFilter(Object.keys(filtersConfig[0])[0], Object.values(filtersConfig[0])[0])}
                </div>
            </Collapsible>
            {/* Filtrs: Ir apmeklēts*/}
            <Collapsible title="Filtrs: bijis/patīk/pievienots maršrutam" defaultCollapsed={true}>
                <div className="list filters">
                    {renderFilterRadioButtons(Object.keys(filtersConfig[1])[0], Object.values(filtersConfig[1])[0])}
                </div>
                {/* Filtrs: Patīk */}
                <div className="list filters">
                    {renderFilterRadioButtons(Object.keys(filtersConfig[2])[0], Object.values(filtersConfig[2])[0])}
                </div>
                {/* Filtrs: pievienots maršrutam */}
                <div className="list filters">
                    {renderFilterRadioButtons(Object.keys(filtersConfig[3])[0], Object.values(filtersConfig[3])[0])}
                </div>
            </Collapsible>
            <Collapsible title="Filtrs: vietas pazīmes" defaultCollapsed={true}>
                <div className="list filters">
                    {renderFilterRadioButtons(Object.keys(filtersConfig[4])[0], Object.values(filtersConfig[4])[0])}
                </div>
            </Collapsible>
            <Collapsible title="Filtrs: reģions" defaultCollapsed={true}>
                <div className="list filters">
                    {renderFilter(Object.keys(filtersConfig[5])[0], Object.values(filtersConfig[5])[0])}
                </div>
            </Collapsible>
            <Collapsible title="Filtrs: tuvākie objekti" defaultCollapsed={true}>
                <div className="list filters">
                    {renderFilter(Object.keys(filtersConfig[6])[0], Object.values(filtersConfig[6])[0], onNearbyChange)}
                </div>
            </Collapsible>
        </>
    );
};

const renderFilter = (filterName, categories, onNearbyChange?: CallableFunction) => {
    const { onFilterItemToggle } = useDemoContext();

    return (
        <>
            {categories.map((item: { title: string; value: string | number | boolean }) => {
                const fieldValue = filterName + "=" + item.value;
                return (
                    <div className="list-item" key={fieldValue}>
                        <input
                            type="checkbox"
                            id={fieldValue}
                            title={fieldValue}
                            defaultChecked={false}
                            onChange={(e) =>
                                onFilterItemToggle(
                                    filterName,
                                    item.value,
                                    { target: { value: e.target.checked ? Option.IS : Option.None } },
                                    onNearbyChange
                                )
                            }
                        ></input>
                        <label htmlFor={fieldValue}>{item.title}</label>
                        <span className="light-text">{"  " + fieldValue}</span>
                    </div>
                );
            })}
        </>
    );
};

const renderFilterRadioButtons = (filterName, categories) => {
    const { onFilterItemToggle } = useDemoContext();

    return (
        <>
            <div>&nbsp; -, IS, NOT</div>
            {categories.map((item: { title: string; value: string | number | boolean }) => {
                const fieldValue = filterName + "=" + item.value;
                return (
                    <div
                        className="list-item"
                        key={fieldValue + "-radio"}
                        onChange={(e) => onFilterItemToggle(filterName, item.value, e)}
                    >
                        <input type="radio" value={Option.None} name={fieldValue} defaultChecked={true} />
                        <input type="radio" value={Option.IS} name={fieldValue} defaultChecked={false} />
                        <input type="radio" value={Option.NOT} name={fieldValue} defaultChecked={false} />
                        <span>{item.title}</span>
                        <span className="light-text">{"  " + fieldValue}</span>
                    </div>
                );
            })}
        </>
    );
};
